export const isUpKey = (key: string) => key === "ArrowUp";

export const isRightKey = (key: string) => key === "ArrowRight";

export const isLeftKey = (key: string) => key === "ArrowLeft";

export const isDownKey = (key: string) => key === "ArrowDown";
